import { useState } from 'react';

import { useForm } from 'react-hook-form';

import { useUpdateProjectPrompt } from '@/entities/project';

import { createModalStore } from '@/shared/lib/modal';
import { MixpanelEvents } from '@/shared/thirdParty';

export type PromptModalProps = {
  projectId: string;
  prompt: string;
};

export const usePromptModalStore = createModalStore<PromptModalProps>({ projectId: '', prompt: '' }, false);

export const usePromptModal = () => {
  const { close, isOpen, open, projectId, prompt } = usePromptModalStore();

  const form = useForm<PromptModalProps>({
    defaultValues: { prompt },
  });

  const updateProjectPrompt = useUpdateProjectPrompt();

  const [isSubmitting, setIsSubmitting] = useState(false);

  const onSubmit = form.handleSubmit(async (data) => {
    MixpanelEvents.retranslationWithPromptFromProject({ prompt: data.prompt });

    if (data.prompt === prompt) return close();

    setIsSubmitting(true);
    try {
      await updateProjectPrompt.mutateAsync({ id: projectId, prompt: data.prompt });

      close();
    } finally {
      setIsSubmitting(false);
    }
  });

  const onCancel = () => {
    MixpanelEvents.cancelPromptFromProject();
    close();
  };

  return { close, form, isOpen, isSubmitting, open, onCancel, onSubmit };
};
